import { useNavigationSettingsContext } from '@app/components/settings/navigation/NavigationSettingsContext';
import { getIsFolderMenuItem, getIsLinkMenuItem, getIsPageMenuItem } from '@app/logic/navigation';
import { isDefined } from '@app/utils/is';
import { Id } from '@typings';

import { FolderMenuItem } from './FolderMenuItem';
import { LinkMenuItem } from './LinkMenuItem';
import { PageMenuItem } from './PageMenuItem';

interface Props {
  onRemoveMenuItem: (id: Id) => void;
  id: Id;
}

export const AddedMenuItem = ({ onRemoveMenuItem, id }: Props) => {
  const { itemRecords } = useNavigationSettingsContext();

  const item = itemRecords[id];

  if (!isDefined(item)) {
    return null;
  }

  if (getIsPageMenuItem(item)) {
    return <PageMenuItem item={item} onRemoveMenuItem={onRemoveMenuItem} />;
  }

  if (getIsLinkMenuItem(item)) {
    return <LinkMenuItem item={item} onRemoveMenuItem={onRemoveMenuItem} />;
  }

  if (getIsFolderMenuItem(item)) {
    return <FolderMenuItem item={item} onRemoveMenuItem={onRemoveMenuItem} />;
  }

  return null;
};
